<template>
    <v-dialog max-width="800px" v-model="sDialog">
        <v-data-table :headers="tableHeaders" :items="questions" class="elevation-1" :rows-per-page-items="rowsPerPageItems">
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.subject }}</td>
                <td class="text-xs-left">{{ props.item.content }}</td>
                <td class="text-xs-left">{{ props.item.questionTime }}</td>
                <td class="text-xs-left">{{ props.item.markScale }}</td>
                <td class="justify-center layout px-0">
                    <v-btn @click="selectQuestion(props.item)" class="mx-0" icon>
                        <v-icon color="primary">library_add_check</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "library-question",

        props: {
            exerciseType: {
                type: String | Number,
                default: null
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            sDialog: false,
            questions: [],
            tableHeaders: [
                {
                    text: "Tên bài tập",
                    align: "left",
                    sortable: false,
                    value: "name"
                },
                {
                    text: "Chủ đề",
                    align: "left",
                    sortable: false,
                    value: "subject"
                },
                {
                    text: "Nội dung",
                    align: "left",
                    sortable: false,
                    value: "content"
                },
                {
                    text: "Thời gian làm bài",
                    align: "left",
                    sortable: false,
                    value: "questionTime"
                },
                {
                    text: "Thang điểm",
                    align: "left",
                    sortable: false,
                    value: "markScale"
                },
                {text: "Chọn", value: "name", align: "center", sortable: false}
            ],
            rowsPerPageItems: [10, 20, 30, 40, 50],

        }),

        watch: {
            value(val) {
                this.sDialog = val;
                this.init();
            },

            sDialog(val){
                this.$emit("input",val);
            }
        },

        created() {
            //this.init();
        },
        methods: {
            init() {
                axios
                    .post(process.env.VUE_APP_API_URL + "/exercise/getQuestionFromLibrary?exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.questions = data;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },
            selectQuestion(question) {
                this.$emit("onSelect", question);
                this.sDialog = false;
            },
        }
    };
</script>